/**
 * Hero stats & part perks (v1.40.0) — labels and helpers shared by Inventory and Missions.
 * Server formulas: api-service ModuleRankServiceImpl.heroStats / LairMath.missionScore.
 */

import i18n from '../../i18n';
import { msg } from '../../i18n/msg';

const t = (...args) => i18n.t(...args);

export const STATS = [
  { key: 'str', label: 'STR', name: msg('stat.strength', 'Strength'), icon: '💪', color: '#ff7a59' },
  { key: 'agi', label: 'AGI', name: msg('stat.agility', 'Agility'), icon: '🏃', color: '#5ee67a' },
  { key: 'int', label: 'INT', name: msg('stat.intellect', 'Intellect'), icon: '🧠', color: '#59a8ff' },
];

const pct = (v) => {
  const n = Math.round((Number(v) || 0) * 1000) / 10;
  return `${Number.isInteger(n) ? n : n.toFixed(1)}%`;
};

// Special bonus of a body part (CharacterModule.PerkType)
export const PERKS = {
  STR_PERCENT: { icon: '💪', text: (v) => t('perk.str', '+{{v}} Strength', { v: pct(v) }) },
  AGI_PERCENT: { icon: '🏃', text: (v) => t('perk.agi', '+{{v}} Agility', { v: pct(v) }) },
  INT_PERCENT: { icon: '🧠', text: (v) => t('perk.int', '+{{v}} Intellect', { v: pct(v) }) },
  MISSION_SPEED: { icon: '⏱', text: (v) => t('perk.mission_speed', '−{{v}} mission time', { v: pct(v) }) },
  MISSION_SUCCESS: { icon: '🎯', text: (v) => t('perk.mission_success', '+{{v}} mission success', { v: pct(v) }) },
  RESOURCE_BONUS: { icon: '⛏', text: (v) => t('perk.resources', '+{{v}} resources', { v: pct(v) }) },
  COIN_BONUS: { icon: '🪙', text: (v) => t('perk.coins', '+{{v}} mission coins', { v: pct(v) }) },
  MODULE_DROP: { icon: '🧩', text: (v) => t('perk.part_drop', '+{{v}} part drop', { v: pct(v) }) },
};

export function perkText(type, value) {
  const meta = PERKS[type];
  if (!meta || !(Number(value) > 0)) return null;
  return `${meta.icon} ${meta.text(value)}`;
}

/** perks: [{type, value}] → value of one type */
export function perkValue(perks, type) {
  return (perks || []).filter((p) => p.type === type).reduce((s, p) => s + (Number(p.value) || 0), 0);
}

/** Stat weights of a mission as shares, non-zero only: [{key, share}] */
export function missionWeights(mission) {
  const w = { str: Number(mission?.strWeight) || 0, agi: Number(mission?.agiWeight) || 0, int: Number(mission?.intWeight) || 0 };
  const sum = w.str + w.agi + w.int;
  if (sum <= 0) return STATS.map((s) => ({ ...s, share: 1 / 3 }));
  return STATS.filter((s) => w[s.key] > 0).map((s) => ({ ...s, share: w[s.key] / sum }));
}
